module.exports = __webpack_public_path__ + "a83bd94555d2d1c62485285892c9ccfd.svg";